import React from "react";
import CurrencyFormat from "react-currency-format";
import { SummaryRow } from "./Summary";

const colorLabel = (title, colorName, colorPrice) => (
	<>
		<span className="summary-label-title">{title}</span>
		{" - "}
		<span className="dark-span">
			{colorName}
			{colorPrice != 0 ? " (Premium)" : ""}
		</span>
	</>
);
const ColorSummarySection = ({ compareParamData, summaryViewData, params }) => {
	const showWallColor = summaryViewData?.wall_color && Object.keys(summaryViewData?.wall_color)?.length > 0;

	return (
		<div className="highlight-with-bg">
			<SummaryRow label={colorLabel("Roof", compareParamData?.p_r_c_name ?? params.p_r_c_name, summaryViewData?.roof_color_price)} price={summaryViewData?.roof_color_price ?? 0} />
			<SummaryRow label={colorLabel("Trim", compareParamData?.p_t_c_name ?? params.p_t_c_name, summaryViewData?.trim_color_price)} price={summaryViewData?.trim_color_price ?? 0} />
			<SummaryRow label={colorLabel("Wall", compareParamData?.p_w_c_name ?? params.p_w_c_name, summaryViewData?.wall_color_price)} price={summaryViewData?.wall_color_price ?? 0} />
		</div>
	);
};

export default ColorSummarySection;

export const WainsCoatSummarySection = ({ summaryViewData, compareParamData, params }) => {
	return (
		<div>
			<div className="section-title-wrapper ">
				<h6 className="section-title mb-0">WAINSCOT</h6>
			</div>
			<div className="highlight-with-bg">
				<SummaryRow label={"Wainscot"} price={summaryViewData?.wainscot_price ?? 0} />
				<SummaryRow label={colorLabel("Color", compareParamData?.p_w_c_c_name ?? params.p_w_c_c_name, summaryViewData?.wainscot_color_price)} price={summaryViewData?.wainscot_price ?? 0} />
			</div>
			<hr />
		</div>
	);
};

export const MaterialSummary = ({ sidingMaterialName, summaryViewData }) => {
	const hasNotMetal = summaryViewData.siding_obj.name != "metal" && summaryViewData.siding_obj.price_type != "$";
	return (
		<>
			<div className="section-title-wrapper ">
				<h6 className="section-title mb-0">Siding Material</h6>
			</div>
			<div className="highlight-with-bg">
				<SummaryRow label={sidingMaterialName} price={hasNotMetal ? (summaryViewData?.siding_material_price ?? 0) : 0} />
			</div>
		</>
	);
};
